import { useState, type FunctionComponent } from 'react';
import Checkbox from './Checkbox';
import * as styles from './ChooseMany.module.css';

export interface ChoiceItem {
  id: number;
  label: string;
  checked: boolean;
  otherChoice: boolean;
  explanation: string | null;
}

interface ChooseManyProps {
  choiceItems: ChoiceItem[];
  onChange: (
    choiceId: number,
    newValue: boolean,
    isOtherChoiceEnabled: boolean,
    newTextValue: string,
    setValueOtherChoice: (value: string) => void,
  ) => void;
  currentValueOtherChoice: string | null | undefined;
  isMaximumReached: boolean;
}

const ChooseMany: FunctionComponent<ChooseManyProps> = ({
  choiceItems,
  onChange,
  currentValueOtherChoice,
  isMaximumReached,
}) => {
  const [valueOtherChoice, setValueOtherChoice] = useState(currentValueOtherChoice || '');
  return (
    <ul className={styles.chooseManyContainer}>
      {choiceItems.map((choiceItem) => {
        const choiceId = choiceItem.id;
        const checkedStyles = choiceItem.checked ? `${styles.checked}` : '';
        const disabledStyles = !choiceItem.checked && isMaximumReached ? `${styles.disabled}` : '';
        const isOtherChoiceEnabled = choiceItem.otherChoice && choiceItem.checked;
        const liOtherChoiceStyles = isOtherChoiceEnabled ? `${styles.liEnabledOtherChoice}` : '';
        const displayExplanation = choiceItem.explanation && choiceItem.checked;
        const liExplanationStyles = displayExplanation ? `${styles.liExplanation}` : '';
        const textareaExplanationStyles = displayExplanation
          ? `${styles.textareaExplanationStyles}`
          : '';

        return (
          <li
            className={`${checkedStyles} ${disabledStyles} ${liOtherChoiceStyles} ${liExplanationStyles}`}
            key={`choose-many-${choiceItem.id}`}
          >
            <Checkbox
              id={choiceItem.id}
              label={choiceItem.label}
              onClick={(nv) =>
                onChange(choiceId, nv, isOtherChoiceEnabled, valueOtherChoice, setValueOtherChoice)
              }
              checked={choiceItem.checked}
              isMaximumReached={isMaximumReached}
            />
            {displayExplanation && (
              <div
                className={`${styles.explanation} ${isOtherChoiceEnabled ? styles.otherChoiceExplanation : ''}`}
                dangerouslySetInnerHTML={{ __html: choiceItem.explanation || '' }}
              />
            )}
            {isOtherChoiceEnabled && (
              <textarea
                id={`otherChoiceTxt${choiceItem.id}`}
                className={`${styles.otherChoice} ${textareaExplanationStyles}`}
                placeholder="Tell us how we can improve"
                value={valueOtherChoice}
                maxLength={4000}
                onChange={(ev) => {
                  setValueOtherChoice(ev.target.value);
                  onChange(
                    choiceId,
                    true,
                    isOtherChoiceEnabled,
                    ev.target.value,
                    setValueOtherChoice,
                  );
                }}
              />
            )}
          </li>
        );
      })}
    </ul>
  );
};

export default ChooseMany;
